<template>
  <admin-layout :sectionTitle="sectionTitle">
    <instant-deal-value></instant-deal-value>
  </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import InstantDealValue from "@/Pages/Admin/InstantDealValue";

export default {
  components: {
    AdminLayout,
    InstantDealValue,
  },

  props: ['sectionTitle']
};
</script>
